import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="w-full bg-background-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mb-8 md:mb-10">
          <div>
            <h3 className="text-lg font-bold font-heading text-background-50 mb-3">黑料视频</h3>
            <p className="text-xs md:text-sm text-background-400 leading-relaxed">
              {footerData.description}
            </p>
          </div>
          {footerData.navGroups.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-100 mb-3">{group.title}</h4>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => handleClick(e, link.href)}
                      className="text-xs md:text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 pt-6 md:pt-8">
          <div className="text-center mb-4">
            <p className="text-xs text-background-500">合作伙伴</p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-background-500">
            <p>&copy; {new Date().getFullYear()} 黑料视频 版权所有</p>
            <div className="flex items-center gap-4">
              <a href="#hero" onClick={(e) => handleClick(e, '#hero')} className="hover:text-accent-400 transition-colors cursor-pointer">
                回到顶部
              </a>
              <a href="#contact" onClick={(e) => handleClick(e, '#contact')} className="hover:text-accent-400 transition-colors cursor-pointer">
                联系我们
              </a>
              <a href="#faq" onClick={(e) => handleClick(e, '#faq')} className="hover:text-accent-400 transition-colors cursor-pointer">
                帮助中心
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}